import { BUTTON_SIZE, DSButton } from '@repo/design-system/index'
import { sendGTMEvent } from '../../helpers/gtmHelper'
import { useTrialCourses } from '../../modules/apis/student/trial'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../modules/hooks/common/useIsWebview'
import { s_trial_lesson } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { STUDENT_BTN_ID } from '../../modules/ids/gtm/student'
import useTrialStore from '../../store/useTrialStore'
import { useBasicPopup } from '../basic/popup/BasicPopup'

interface IMaterialSelectButton {
  materialId: number
}

const MaterialSelectButton: React.FC<IMaterialSelectButton> = ({ materialId }) => {
  const { t } = useTranslation()
  const { data } = useTrialCourses()
  const popup = useBasicPopup()
  const isMobile = useIsMobile()
  const isWebView = useIsWebview()
  const setCourse = useTrialStore((state) => state.setCourse)

  const handleCourseSelectionClick = () => {
    sendGTMEvent(STUDENT_BTN_ID.CLICK_TRIAL_SELECT_MATERIAL, {
      custom_page_title: 'material_detail',
      device_type: isMobile ? (isWebView ? 'app' : 'mobile_web') : 'pc_web',
    })
    popup.close('packet-modal')
    setCourse(data.categories.flatMap((category) => category.courses).find((course) => course.id === materialId))
  }
  return (
    <>
      <div className="w-[335px] sm:w-[160px]">
        <DSButton size={BUTTON_SIZE.LG} onClick={handleCourseSelectionClick}>
          <DSButton.Label>{t(s_trial_lesson.book.btn_material)}</DSButton.Label>
        </DSButton>
      </div>
    </>
  )
}

export default MaterialSelectButton
